import React from "react";

export function SummaryBanner({ title, text, testId }) {
  return (
    <div className="border border-gray-200 bg-gray-50/60 p-5 md:p-6" data-testid={testId}>
      <div className="flex items-start gap-4">
        <div className="w-1 self-stretch bg-[#5E3BFF] min-h-[2.5rem]" />
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-gray-500 font-bold">
            Executive Summary
          </div>
          <div className="mt-1 font-display text-xl md:text-2xl font-bold tracking-tight text-gray-950">
            {title}
          </div>
          <div className="mt-2 text-sm text-gray-600 max-w-3xl leading-relaxed">{text}</div>
        </div>
      </div>
    </div>
  );
}

export function SectionBox({ title, eyebrow, description, children, testId, action }) {
  return (
    <section className="border border-gray-200 p-6" data-testid={testId}>
      <div className="mb-5 flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-gray-500 font-bold">
            {eyebrow}
          </div>
          <h3 className="font-display text-xl font-bold tracking-tight mt-1 text-gray-950">
            {title}
          </h3>
          {description ? (
            <p className="text-sm text-gray-500 mt-2 max-w-3xl">{description}</p>
          ) : null}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}

export function EmptyBlock({ text }) {
  return (
    <div className="py-10 text-center text-sm text-gray-500 border border-dashed border-gray-300">
      {text}
    </div>
  );
}
